import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import { AuthProvider } from './contexts/AuthContext';
import HomePage from './pages/Home';
import LoginPage from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ForgotPasswordReset from './pages/ForgotPasswordReset';
import Register from './pages/Register';
import VerifyAccount from './pages/VerifyAccount';
import config from './config';
import ProjectsList from './pages/ProjectsList';
import ProjectHome from './pages/Project';
import GuideHome from './pages/Guide';
import GuideHomeUpload from './pages/GuideUpload';
import Page404 from './pages/404';
import Platform from './pages/Platform';
import Contact from './pages/Contact';
import Publish from './pages/Publish';
import Settings from './pages/Settings';

function App() {
  return (
    <Container>
    <AuthProvider>
    <Router>
      <Routes>
        <Route path='/' element={<Navigate to={`${config.prefixPath}/`} />} />
        <Route path={`${config.prefixPath}/login`} element={<LoginPage />} />
        <Route path={`${config.prefixPath}/register`} element={<Register />} />
        <Route path={`${config.prefixPath}/forgot-password`} element={<ForgotPassword />} />
        <Route path={`${config.prefixPath}/forgot-password/:hash`} element={<ForgotPasswordReset />} />
        <Route path={`${config.prefixPath}/verify-account/:token`} element={<VerifyAccount />} />
        <Route path={config.prefixPath} element={<HomePage />} />
        <Route path={`${config.prefixPath}/projects`} element={<ProjectsList />} />
        <Route path={`${config.prefixPath}/projects/:project`} element={<ProjectHome />} />
        <Route path={`${config.prefixPath}/projects/:project/guides/:guide`} element={<GuideHome />} />
        <Route path={`${config.prefixPath}/projects/:project/guides/:guide/#step`} element={<GuideHome />} />
        <Route path={`${config.prefixPath}/projects/:project/guides/:guide/remote-upload`} element={<GuideHomeUpload />} />
        
        <Route path={`${config.prefixPath}/platform`} element={<Platform />} />
        <Route path={`${config.prefixPath}/publish`} element={<Publish />} />
        <Route path={`${config.prefixPath}/settings`} element={<Settings />} />
        <Route path={`${config.prefixPath}/contact`} element={<Contact />} />
        <Route path="*"element={<Page404/>}/>
      </Routes>
    </Router>
    </AuthProvider>
    </Container>
  );
}

export default App;
